import { render, staticRenderFns } from "./DatetimeColumn.vue?vue&type=template&id=122c54b6"
import script from "./DatetimeColumn.vue?vue&type=script&lang=js"
export * from "./DatetimeColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports